import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@chakra-ui/react'
import { DragHandleIcon } from '@chakra-ui/icons'

const DragHandler = ({ provided }) => {
  return (
    <Flex
      {...provided.dragHandleProps}
      cursor="move"
      position="absolute"
      top={0}
      w="16px"
      h="28px"
      alignItems="center"
      justifyContent="center">
      <DragHandleIcon
        fontSize="14px"
        color="brand.gray"
      />
    </Flex>
  )
}

DragHandler.propTypes = {
  provided: PropTypes.any,
}

export default DragHandler
